export enum DataConsumeType {
    AUTH = 'AUTH', // consume data from authentication
    AXWAY = 'AXWAY', // consume data from axway token,
    APIM_TINEA = 'APIM_TINEA' // consume data from APIM Tinea,
}
